import React from "react";
import GestionDesSites from "../components/GestionDesSites";
import RecuperationDesDonnees from "../components/RecuperationDesDonnees";
import AssociationsEditor from "../components/AssociationsEditor";

export default function Gestion() {
  return (
    <div className="flex flex-col gap-4">
      {/* Ligne 1 — Deux colonnes : Sites + Récupération */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start">
        <GestionDesSites />
        <RecuperationDesDonnees />
      </div>

      {/* Ligne 2 — Association formulaires ↔ sites (pleine largeur) */}
      <AssociationsEditor />
    </div>
  );
}
